import { useState } from 'react'

import { faFilter } from '@fortawesome/pro-solid-svg-icons'

import IconButton from '../antd/Buttons/IconButton'
import { isFunction } from 'lodash'

const Expandable = ({ children, className, defaultExpanded = false, onExpandChange }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  const style = isExpanded ? { borderRight: '1px solid #d9d9d9' } : { }

  const handleToggle = () => {
    const newExpanded = !isExpanded

    setIsExpanded(newExpanded)
    if (isFunction(onExpandChange)) {
      onExpandChange(newExpanded)
    }
  }

  return (
    <div className='flex-row h-100 settings'>
      <div className='btn-small pd-4' style={style}>
        <IconButton icon={faFilter} onClick={handleToggle} />
      </div>

      {isExpanded && (
        <div className='h-100' style={{ width: 'calc(100% - 38px)' }}>
          {children}
        </div>
      )}
    </div>
  )
}

export default Expandable
